import { BaseActions } from '@/models/Common/Actions/BaseActions';
import { MemberNewRequestBuilder, MemberViewRequestBuilder } from '@/models/Member/MemberNewRequestBuilder';
import { IMemberNewClaimsRequestParams } from '@/models/Member/interfaces/IMemberNewClaimsRequestParams';
import { IMemberInternalGetCertRequestParams } from '@/models/Member/interfaces/IMemberInternalGetCertRequestParams';
import { IMemberViewCreateTokenRequestParams } from '@/models/Member/interfaces/IMemberViewCreateTokenRequestParams';
import { ResponseEither } from '@/models/Common/ResponseEither';
import { execAction } from '@/models/Common/Actions/handler';
import debug from 'debug';
import { IMemberNewNolInfoRequestParams } from '@/models/Member/interfaces/IMemberNewNolInfoRequestParams';
import { IMemberNewNolInfoPayload } from '@/models/Member/interfaces/payloads/IMemberNewNolInfoPayload';
import { IMemberNewNolCheckConnectRequestParams } from '@/models/Member/interfaces/IMemberNewNolCheckConnectRequestParams';

const log = debug('sunny:MemberNewAction');

export class MemberNewActions extends BaseActions<MemberNewRequestBuilder> {
  claims(params: IMemberNewClaimsRequestParams): Promise<ResponseEither<any>> {
    log('Getting information of claims');
    return execAction('memberNew', this.requestBuilder.createPostClaims(params), undefined, [404]);
  }

  nolCheckConnect(params: IMemberNewNolCheckConnectRequestParams): Promise<ResponseEither<never>> {
    log('Getting information of nol connect');
    const ignoreStatusCodes = [201, 202, 400, 404, 409];
    return execAction('memberNew', this.requestBuilder.createPutNolCheckConnect(params), undefined, ignoreStatusCodes);
  }

  /**
   * https://yanolja.atlassian.net/wiki/spaces/YAMEMBER/pages/70321335
   * 회원 정보 조회 API > 회원 PLCC 정보 상세 조회 API
   */
  nolInfo(params: IMemberNewNolInfoRequestParams): Promise<ResponseEither<IMemberNewNolInfoPayload>> {
    log('Getting information of nol');
    return execAction('nolInfo', this.requestBuilder.createGetNolInfo(params));
  }

  getCert(params: IMemberInternalGetCertRequestParams): Promise<ResponseEither<any>> {
    log('Getting information of get cert');
    return execAction('memberInternal', this.requestBuilder.createGetCert(params));
  }
}

export class MemberViewActions extends BaseActions<MemberViewRequestBuilder> {
  createToken(params: IMemberViewCreateTokenRequestParams): Promise<ResponseEither<any>> {
    log('Getting information of create token');
    return execAction('memberView', this.requestBuilder.createPostToken(params));
  }
}
